// extracted by mini-css-extract-plugin
export default {"emailDetails":"Contact_emailDetails__TuoG+","emailButtons":"Contact_emailButtons__5IiMn","emailhead":"Contact_emailhead__KwcNZ"};